import { render, staticRenderFns } from "./Variance.vue?vue&type=template&id=0faae960&scoped=true"
import script from "./Variance.vue?vue&type=script&lang=js"
export * from "./Variance.vue?vue&type=script&lang=js"
import style0 from "./Variance.vue?vue&type=style&index=0&id=0faae960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faae960",
  null
  
)

export default component.exports